import SiteCreateView from './SiteCreateView';
import './SiteCreateView.scss';

export default SiteCreateView;
